'use client';

import { navigationConfig } from '@/components/navigation/navigation.config';
import { useLocalePath } from '@/shared/hooks';
import { cn } from '@/lib/shadcn/utils';
import { useT } from 'next-i18next/client';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import type { FC } from 'react';

export const MainNavigation: FC = () => {
  const { t } = useT(navigationConfig.i18nNamespaces);
  const pathname = usePathname();
  const { to } = useLocalePath();

  const links = [
    { href: to('/projects'), label: t('navigation:topNav.projects') },
    { href: to('/services'), label: t('navigation:topNav.services') },
    { href: to('/process'), label: t('navigation:topNav.process') },
    { href: to('/about'), label: t('navigation:topNav.about') },
  ];

  return (
    <nav className="flex items-center gap-8">
      {links.map(({ href, label }) => (
        <Link
          key={href}
          href={href}
          className={cn(
            'text-sm font-medium transition-colors duration-150',
            pathname === href ? 'text-white' : 'text-white/60 hover:text-white'
          )}
        >
          {label}
        </Link>
      ))}
    </nav>
  );
};
